import React, {useEffect, useState} from 'react';
import Header from "../../components/header";
import Calculate from "../../components/calculate";
import s from './styles.module.css'
import InputRange from "../../components/input_range";
import ModalElement from "./modal";
import Empty from "../../components/empty";
import api from "../../api";

const Elements = ({data, setData, setPage, headerData, isArtistik, confirm, status, selectedValues}) => {
    const [selected, setSelected] = useState(null)
    const [nameSelected, setNameSelected] = useState(null)
    const [value, setValue] = useState(0)
    const [openModal, setOpenModal] = useState(false)
    const [score, setScore] = useState(false)

    const updateDataValue = (id, value) => {
        setData(data.map((el) => (isArtistik ? el.artistic_type_id : el.score_element_id) === id ? ({
            ...el,
            value: value
        }) : el))
    }

    useEffect(() => {

        if (status !== 'wait') {
            setOpenModal(false)
        }

        if (status === 'update') {
            setSelected(null)
            setValue(0)
        }
    }, [status])

    useEffect(() => {
        setData(data.map((el) => ({...el, value: el.value})))
    }, [status])

    function sendRequest(sendValue, scoreId, token) {
        console.log("SendRequest: " + sendValue)
        const elementSender = async () => {
            await api().post(`/coach/element/send/${scoreId}/${sendValue}/${token}`).then(async () => {
            })
        }

        const artisticSender = async () => {
            await api().post(`/coach/impression/send/${scoreId}/${sendValue}/${token}`).then(async () => {
            })
        }

        if (selectedValues.coach_type_id === 1) {
            elementSender().then(() => {
            });
        }

        if (selectedValues.coach_type_id === 2) {
            artisticSender().then(() => {
            });
        }
    }

    return (
        <div className={s.elements}>
            <Header disabled={data?.length === 0 || !data} openModal={() => setOpenModal(true)}
                    headerData={headerData}/>

            {(data?.length === 0 || !data) ? <Empty/> : <div className={s.content}>
                <div className={s.calculate_box}>
                    <Calculate sendRequest={sendRequest} score={score} setValue={setValue} value={value}
                               disabled={selected === null || nameSelected === 'SuCon'}/>
                </div>
                {status !== 'update' && <div className={s.input_range_box}>
                    {data?.map((el, i) => <InputRange updateDataValue={updateDataValue}
                                                      sendRequest={sendRequest}
                                                      resetCalculate={() => setValue(null)}
                                                      valueCalculate={value}
                                                      selectedValues={selectedValues}
                                                      setSelected={setSelected}
                                                      selected={selected}
                                                      setScore={setScore}
                                                      scoreId={isArtistik ? el.score_artistic_id : el.score_element_id}
                                                      key={isArtistik ? el.score_artistic_id : el.score_element_id}
                                                      startValue={el.value}
                                                      id={isArtistik ? el.artistic_type_id : el.score_element_id}
                                                      title={isArtistik ? el.artistic_type_name : el.part}
                                                      index={isArtistik ? el.artistic_type_id : +el.number}
                                                      setNameSelected={setNameSelected}/>
                    )}
                </div>}
            </div>}
            {openModal &&
                <ModalElement isArtistik={isArtistik} confirm={confirm} setPage={setPage} open={openModal}
                              onClose={() => setOpenModal(false)} data={data} status={status}/>}
        </div>
    );
};

export default Elements;
